import * as api from './api';
import * as types from './mutations';

const state = {
    latestCourses: [],
    popularCourses: [],
    fetchedCourses: {},
    courseContent: {},
    isProcessing: false
};

const getters = {
    course(state) {
        return function (courseSlug) {
            return state.fetchedCourses[courseSlug] && state.fetchedCourses[courseSlug];
        }
    },

    relatedCourses(state) {
        return function (courseSlug) {
            return state.fetchedCourses[courseSlug] && state.fetchedCourses[courseSlug].relatedCourses.data;
        }
    },
};

const mutations = {
    [types.SET_PROCESSING_STATE](state, isProcessing) {
        state.isProcessing = isProcessing;
    },

    [types.SET_LATEST_COURSES](state, courses) {
        state.latestCourses = courses;
    },

    [types.SET_POPULAR_COURSES](state, courses) {
        state.popularCourses = courses;
    },

    [types.UPDATE_FETCHED_COURSES](state, {courseSlug, courseData}) {
        state.fetchedCourses[courseSlug] = courseData;
    },

    [types.UPDATE_COURSES_CONTENT](state, {courseSlug, courseData}) {
        state.courseContent = {...state.courseContent, [courseSlug]: courseData};
    }
};

const actions = {
    getLatestCourses({commit}) {
        axios.get(api.getLatestCourses)
            .then(({data}) => {
                commit(types.SET_LATEST_COURSES, data.courses.data);
            });
    },

    getPopularCourses({commit}) {
        axios.get(api.getPopularCourses)
            .then(({data}) => {
                commit(types.SET_POPULAR_COURSES, data.courses.data);
            });
    },

    getCourseOverview({commit, state}, {courseSlug}) {
        // If course's overview has been fetched before
        // Then we simulate loading and return the cached course.
        if (state.fetchedCourses[courseSlug]) {
            commit(types.SET_PROCESSING_STATE, true);
            setTimeout(() => {
                return state.fetchedCourses[courseSlug];
            }, _.random(500, 1000));
        }
        
        return new Promise((resolve, reject) => {
            commit(types.SET_PROCESSING_STATE, true);

            axios.get(api.getCourseOverview(courseSlug))
                .then(({data}) => {
                    commit(types.UPDATE_FETCHED_COURSES, {courseSlug, courseData: data.course.data});
                    resolve(data.course.data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};